import * as React from 'react';
import * as styles from './Gallery.css';
import "../../../styles/BasicIA.css";
import { Controller } from '../controller/Controller';
import { IComposerImage } from '../../../interfaces/IComposerImage';
import { IComposerGallery } from '../../../interfaces/IComposerGallery';
// import { IAIcon } from '../../icon/Icon';
import { Rotator } from './rotator/Rotator';
import { Collage } from './collage/Collage';
import { Tiles } from './tiles/Tiles';
import { LocalizationService } from '../../../services/LocalizationService';
import { inject, observer } from 'mobx-react';
import { Store } from '../stores';
import UploaderService from '../../../services/UploaderService';
import { ComposerHelper } from '../helper/ComposerHelper';
import { IASpinner } from '../../spinner/Spinner';
import { IAComposerPlaceholder } from '../placeholders/ComposerPlaceholder';
import { Helper } from '../../../Helper';

export interface IProps {
  store?: Store;
  gallery: IComposerGallery;
  id: string;
  index?: number;
  hideToolbox: boolean;
  showDropZones: boolean;
  isInMobileToolbox?: boolean;
  openImageViewer?: (images: IComposerImage[], index: number) => void;
  onFocus?: () => void;
  onChange: (gallery: IComposerGallery) => void;
  onDrag?: () => void;
  onDragEnd?: () => void;
}

export interface IState {
  dragging: boolean;
  showController: boolean;
  showImageCropper: boolean;
  loadedOrgAssetPath: string;
  showDropZones: boolean;
  imageFormatError: boolean;
  imageUploadError: "too big" | "failed" | "";
  uploadedElements: number;
  totalElementsToUpload: number;
}

@inject('store')
@observer
export class Gallery extends React.Component<IProps, IState> {

  private readonly localizationService: LocalizationService = new LocalizationService();

  constructor(props: IProps) {
    super(props);
    this.state = {
      dragging: false,
      showController: this.props.isInMobileToolbox ? true : false,
      showImageCropper: false,
      loadedOrgAssetPath: undefined,
      showDropZones: false,
      imageFormatError: false,
      imageUploadError: "",
      uploadedElements: undefined,
      totalElementsToUpload: undefined
    };
    this.localizationService?.checkLocalizedStrings().then(() => this.forceUpdate());
    document.body.addEventListener('click', (event: any) => {
      var exceptions = '#IA_gallery *, #IA_toolboxContent *, #IA_OrgAssetsUploader *, #IA_imageViewer *';
      if (!event.target.matches(exceptions) && this.props.store.activeComponent && this.props.store.activeComponent.id === this.props.id) {
        this.hideToolbox()
        if(!this.props.store.isGalleryImagesUploading) this.props.store.activeComponent = undefined;
      }
    });
  }

  public componentWillReceiveProps(props: IProps): void {
    if (props.hideToolbox) {
      this.hideToolbox();
    }
    if (this.props.hideToolbox !== props.hideToolbox && props.hideToolbox != undefined && !props.hideToolbox) {
      this.setState({ showController: true });
    }
    if (props.showDropZones) {
      this.hideToolbox()
    }
    this.loadGalleryImages();
    if (props.showDropZones !== this.props.showDropZones) {
      setTimeout(() => {
        this.setState({ showDropZones: props.showDropZones });
      }, 0);
    }
  }

  private getGalleryPath(): string {
    return this.props.gallery.organizationalAssetPath + this.props.gallery.sortOrder;
  }

  private loadGalleryImages(): void {
    if (this.props.gallery.source === "OrganizationalAssets"
      && this.props.gallery.organizationalAssetPath
      && this.props.gallery.organizationalAssetInfo
      && this.state.loadedOrgAssetPath !== "loading"
      && (this.state.loadedOrgAssetPath === undefined || (this.state.loadedOrgAssetPath !== undefined && this.state.loadedOrgAssetPath !== this.getGalleryPath()))) {
      this.setState({ loadedOrgAssetPath: "loading" });
      this.props.gallery.images = [];
      UploaderService.getFilesByListServerRelativeUrl(
        this.props.store.environment,
        this.props.store.token,
        this.props.store.tenant,
        this.props.gallery.organizationalAssetInfo.site,
        this.props.gallery.organizationalAssetPath,
        this.props.gallery.sortOrder
      ).then((files: any[]) => {
        this.insertGalleryImages(files);
      });

    }
  }

  private insertGalleryImages(files: any[]){
    if (files && files.length > 0) {
      const images = [];
      files.forEach((file: any) => {
        if (file.url.indexOf(this.props.gallery.organizationalAssetPath) != -1 && (file.url.indexOf(".jpg") != -1 || file.url.indexOf(".jpeg") != -1 || file.url.indexOf(".png") != -1 || file.url.indexOf(".gif") != -1)) {
          images.push({
            name: file.name,
            url: file.url
          });
        }
      });
      this.props.gallery.images = images;
    }
    this.setState({ loadedOrgAssetPath: this.getGalleryPath() });
  }

  private showToolbox(): void {
    this.setState({ showController: true });
  }

  private hideToolbox(): void {
    this.setState({ showController: false });
  }

  private async recursivelyUploadFiles(files: FileList, site: string, serverRelativeUrl: string, index: number, uploadedImages: IComposerImage[]) {
    await ComposerHelper.uploadFileDirectlyToSharepoint(
        this.props.store.environment,
        files.item(index),
        this.props.store.tenant,
        this.props.store.token,
        () => {},
        site,
        serverRelativeUrl)
      .then(fileUrl => {
         this.handleFileUploaded(files, site, serverRelativeUrl, index, [...uploadedImages, { url: fileUrl }]);
      }).catch(() => {
        this.handleFileUploaded(files, site, serverRelativeUrl, index, uploadedImages);
      });
  }

  private handleFileUploaded(files: FileList, site: string, serverRelativeUrl: string, index: number, uploadedImages: IComposerImage[]){
      this.setState({ uploadedElements: this.state.uploadedElements ? this.state.uploadedElements + 1 : 1 }, () => {
      if (this.state.uploadedElements === this.state.totalElementsToUpload) {
        setTimeout(() => {
          this.setState({ totalElementsToUpload: undefined, uploadedElements: undefined });
          this.props.gallery.images = [...this.props.gallery.images, ...uploadedImages];
          this.props.store.isUploadingVideoOrImage = false;
        }, 500);
      } else {
        this.recursivelyUploadFiles(files, site, serverRelativeUrl, index + 1, uploadedImages);
      }
      });
  }

  private getGalleryStatus(): "success" | "waiting" | "error" {
    if (this.state.imageUploadError || this.state.imageFormatError) {
      return "error";
    }
    if (!this.props.gallery.images || this.props.gallery.images.length === 0) {
      return "waiting";
    }
    return "success";
  }


  private galleryOnClick(): void {
    setTimeout(() => {
      this.props.onFocus();
      this.showToolbox();
    }, 100);
  }

  private getPlaceholderText(): string {
    if (this.props.gallery.images.length > 0) return this.localizationService.strings.Composer_AddMoreImagesToGallery;
    if (this.props.gallery.source === "Upload" && this.props.store.activeComponent && this.props.store.activeComponent.id === this.props.id) {
      return this.localizationService.strings.Composer_DropImagesHere;
    }
    return this.localizationService.strings.Composer_SelectAFolderInYourOrgAssets;
  }

  public render(): JSX.Element {
    const galleryStatus = this.getGalleryStatus();
    let gallery;
    switch (this.props.gallery.type) {
      case "Rotator":
        gallery = (
          <Rotator
            images={this.props.gallery.images}
            token={this.props.store.token}
            tenant={this.props.store.tenant}
            isMobile={this.props.store.isMobile}
            environment={this.props.store.environment}
            editMode
            openImageViewer={() => {}}
            bordeRadius={this.props.gallery.borderRadius}
          />
        );
        break;
      case "Tiles":
        gallery = (
          <Tiles
            maxImages={this.props.gallery.maxImages}
            images={this.props.gallery.images}
            token={this.props.store.token}
            tenant={this.props.store.tenant}
            environment={this.props.store.environment}
            editMode
            openImageViewer={() => {}}
            bordeRadius={this.props.gallery.borderRadius}
          />
        );
        break;
      case "Collage":
        gallery = (
          <Collage
            maxImages={this.props.gallery.maxImages}
            images={this.props.gallery.images}
            token={this.props.store.token}
            tenant={this.props.store.tenant}
            environment={this.props.store.environment}
            editMode
            openImageViewer={() => {}}
            bordeRadius={this.props.gallery.borderRadius}
          />
        );
        break;
      default:
        break;
    }
    return (
      <div
        id={"IA_gallery"}
        className={styles.IA_image}
      >
        {this.state.loadedOrgAssetPath === "loading"
        ?
          <div style={{height: 251, paddingTop: 100}}>
            <IASpinner color={this.props.store.highlightColor}/>
          </div>
        :
        <>
          <Controller
            visible={this.state.showController && !this.state.showDropZones}
            highlightColor={this.props.store.highlightColor}
            onDublicate={!this.props.isInMobileToolbox ? () => this.props.store.dublicateComponent() : undefined}
            onDelete={() => {
              if (this.props.store.activeComponent.gallery && this.props.store.activeComponent.gallery.images && this.props.store.activeComponent.gallery.images.length > 0) {
                this.props.store.activeComponent.gallery = {
                  source: "Upload",
                  type: "Tiles",
                  maxImages: 10,
                  images: []
                };
              } else {
                this.props.store.removeComponentAtIndex(this.props.index);
                this.hideToolbox()
                this.props.store.activeComponent = undefined;
              }
              this.forceUpdate();
            }}
            onDrag={this.props.onDrag ? () => this.props.onDrag() : undefined}
            onDragEnd={this.props.onDragEnd ? () => this.props.onDragEnd() : undefined}
          />
          {this.state.showDropZones && this.props.index === 0 && !this.state.showController &&
            <div
              className={styles.IA_dropZones}
              style={{
                marginBottom: 10
              }}
              onDragOver={(event) => {
                event.preventDefault();
              }}
              onDragEnter={(event) => {
                event.preventDefault();
              }}
              onDropCapture={(event) => {
                event.preventDefault();
                if (this.props.store.startIndex != undefined) {
                  this.props.store.moveComponentAtIndex(0);
                } else {
                  this.props.store.addComponentAtIndex(0);
                }
              }}
            />
          }
          <div style={{
            width: "100%",
            height: this.props.gallery.images.length > 0 ? "auto" : (this.props.store.isMobile ? (screen.width - 100) / 16 * 9 : 349),
            float: "left",
          }}
          onClick={() => this.galleryOnClick()}
          >
            {galleryStatus === "success" &&
              gallery
            }
            {(this.props.gallery.source === "Upload" || galleryStatus === "waiting") &&
              <div
                style={{
                  marginTop: this.props.gallery.images.length > 0 ? "5px" : "0px",
                  height: "100%"
                }}
              >
                <IAComposerPlaceholder
                  id={Helper.getRandomStringKey()}
                  enableUpload={this.props.gallery.source === "Upload"}
                  isActive={this.props.store.activeComponent && this.props.store.activeComponent.id === this.props.id}
                  highlightColor={this.props.store.highlightColor}
                  icon={{
                    name: "ImageGallery2",
                    size: 60
                  }}
                  borderRadius={this.props.gallery.borderRadius}
                  showSpinner={false}
                  progressBarPercentage={this.state.totalElementsToUpload !== undefined && this.state.uploadedElements !== undefined ? (this.state.uploadedElements / this.state.totalElementsToUpload) * 100 : undefined}
                  progressBarText={this.state.totalElementsToUpload !== undefined && this.state.uploadedElements !== undefined ? `${this.state.uploadedElements}/${this.state.totalElementsToUpload} ${this.localizationService.strings.Composer_GalleryImageUploadedProgress}` : undefined}
                  text={this.getPlaceholderText()}
                  uploadButtonText={this.localizationService.strings.Composer_SelectFromMediaLibrary}
                  multiUpload
                  uploadMultipleFilesCallback={(files) => {
                      this.setState({ totalElementsToUpload: files.length });
                      this.props.store.isUploadingVideoOrImage = true;
                      let site: string;
                      let serverRelativeUrl: string;
                      if (this.props.gallery.organizationalAssetPath) {
                        site = this.props.gallery.organizationalAssetPath.split("/")[2];
                        serverRelativeUrl = this.props.gallery.organizationalAssetPath.split(`/${site}/`)[1];    
                      }
                      return this.recursivelyUploadFiles(files, site, serverRelativeUrl, 0, []);
                  }}
                  onClick={() => this.galleryOnClick()}
                />
              </div>
            }
          </div>
          {
            this.state.showDropZones && !this.state.showController &&
            <div
              className={styles.IA_dropZones}
              style={{
                marginTop: 10
              }}
              onDragOver={(event) => {
                event.preventDefault();
              }}
              onDragEnter={(event) => {
                event.preventDefault();
              }}
              onDropCapture={(event) => {
                event.preventDefault();
                event.preventDefault();
                if (this.props.store.startIndex != undefined) {
                  this.props.store.moveComponentAtIndex(this.props.index + 1);
                } else {
                  this.props.store.addComponentAtIndex(this.props.index + 1);
                }
              }}
            />
          }
        </>
        }
      </div >
    );
  }
}